/* ASN Care theme scripts */
(function () {
  'use strict';

  var body = document.body;
  var scrollLocks = 0;

  function lockScroll() {
    scrollLocks += 1;
    body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (scrollLocks === 0) body.style.overflow = '';
  }

  function money(cents) {
    var format = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: format }).format(cents / 100);
    } catch (e) {
      return '€ ' + (cents / 100).toFixed(2);
    }
  }

  /* ----------------------------------------------------------------------
     Navigatielade
     ---------------------------------------------------------------------- */

  var navDrawer = document.querySelector('[data-nav-drawer]');

  function openNav() {
    if (!navDrawer) return;
    navDrawer.hidden = false;
    lockScroll();
    var btn = document.querySelector('[data-nav-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeNav() {
    if (!navDrawer || navDrawer.hidden) return;
    navDrawer.hidden = true;
    unlockScroll();
    var btn = document.querySelector('[data-nav-toggle]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  /* ----------------------------------------------------------------------
     Winkelwagenlade
     ---------------------------------------------------------------------- */

  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    lockScroll();
  }

  function closeCart() {
    if (!cartDrawer || cartDrawer.hidden) return;
    cartDrawer.hidden = true;
    unlockScroll();
  }

  function refreshCart(shouldOpen) {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer]');
        if (!fresh || !cartDrawer) return;
        var wasOpen = !cartDrawer.hidden;
        cartDrawer.innerHTML = fresh.innerHTML;
        cartDrawer.hidden = !(wasOpen || shouldOpen);
        if (cartDrawer.hidden && wasOpen) unlockScroll();
        if (!wasOpen && shouldOpen) lockScroll();
        cartDrawer = document.querySelector('[data-cart-drawer]');
      })
      .then(updateCartCount);
  }

  function updateCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        return cart;
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    if (cartDrawer) cartDrawer.classList.add('is-busy');
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return refreshCart(false); })
      .finally(function () {
        if (cartDrawer) cartDrawer.classList.remove('is-busy');
      });
  }

  /* ----------------------------------------------------------------------
     Globale klikafhandeling
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (target.closest('[data-nav-toggle]')) { event.preventDefault(); openNav(); return; }
    if (target.closest('[data-nav-close]')) { event.preventDefault(); closeNav(); return; }
    if (target.closest('[data-cart-toggle]')) { event.preventDefault(); openCart(); return; }
    if (target.closest('[data-cart-close]')) { event.preventDefault(); closeCart(); return; }

    var step = target.closest('[data-qty-up], [data-qty-down]');
    if (step) {
      event.preventDefault();
      var wrap = step.closest('[data-qty]');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var next = parseInt(input.value, 10) || 0;
      next = step.hasAttribute('data-qty-up') ? next + 1 : Math.max(parseInt(input.min || '0', 10), next - 1);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var dropdown = target.closest('.header__dropdown');
    if (!dropdown) {
      document.querySelectorAll('.header__dropdown[open]').forEach(function (el) { el.open = false; });
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input][data-line]');
    if (!input) return;
    changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeNav();
    closeCart();
    document.querySelectorAll('.header__dropdown[open]').forEach(function (el) { el.open = false; });
  });

  /* ----------------------------------------------------------------------
     Toevoegen aan winkelwagen
     ---------------------------------------------------------------------- */

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-product-form], .product-form')) return;
    event.preventDefault();

    var button = form.querySelector('[data-add-button]');
    var label = button ? button.textContent : '';
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Bezig...';
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (result) {
        var errorEl = form.querySelector('[data-form-error]');
        if (!result.ok) {
          if (errorEl) {
            errorEl.textContent = result.data.description || result.data.message || 'Dit product kon niet worden toegevoegd.';
            errorEl.hidden = false;
          }
          return;
        }
        if (errorEl) errorEl.hidden = true;
        return refreshCart(true);
      })
      .catch(function () {})
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.textContent = label;
        }
      });
  });

  /* ----------------------------------------------------------------------
     Productpagina: varianten en galerij
     ---------------------------------------------------------------------- */

  function initProduct(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var addButton = root.querySelector('[data-add-button]');
    var skuEl = root.querySelector('[data-variant-sku]');
    var stockEl = root.querySelector('[data-variant-stock]');
    var kortingEl = root.querySelector('[data-variant-korting]');
    var gallery = root.querySelector('[data-gallery]');

    var groups = root.querySelectorAll('[data-option-group]');

    function currentSelection() {
      var values = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        if (checked) values.push(checked.value);
        else if (select) values.push(select.value);
      });
      return values;
    }

    function update() {
      var match;

      if (!groups.length) {
        var currentId = idInput && idInput.value;
        match = variants.find(function (variant) { return String(variant.id) === String(currentId); }) || variants[0];
      } else {
        var values = currentSelection();
        match = variants.find(function (variant) {
          return variant.options.every(function (opt, i) { return opt === values[i]; });
        });
      }

      if (!match) {
        if (addButton) {
          addButton.setAttribute('aria-disabled', 'true');
          addButton.textContent = 'Niet beschikbaar';
        }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl && groups.length) {
        var html = '<span class="price__current">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s class="price__compare">' + money(match.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--sale', !!(match.compare_at_price && match.compare_at_price > match.price));
      }
      if (skuEl) skuEl.textContent = match.sku || '';
      if (kortingEl) {
        var pct = 0;
        if (match.compare_at_price && match.compare_at_price > match.price) {
          pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
        }
        kortingEl.textContent = '-' + pct + '%';
        kortingEl.hidden = pct <= 0;
      }
      if (stockEl) {
        var opVoorraad = stockEl.getAttribute('data-stock-in') || 'Op voorraad, vandaag verzonden';
        stockEl.textContent = match.available ? opVoorraad : 'Tijdelijk uitverkocht';
        stockEl.classList.toggle('is-out', !match.available);
      }
      if (addButton) {
        if (match.available) {
          addButton.removeAttribute('aria-disabled');
          addButton.textContent = 'In winkelwagen';
        } else {
          addButton.setAttribute('aria-disabled', 'true');
          addButton.textContent = 'Uitverkocht';
        }
      }

      if (gallery && match.featured_media) {
        var slide = gallery.querySelector('[data-media-id="' + match.featured_media.id + '"]');
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }

      if (groups.length && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-group]')) update();
    });

    update();
  }

  document.querySelectorAll('[data-product-root]').forEach(initProduct);

  /* ----------------------------------------------------------------------
     Productgalerij thumbnails
     ---------------------------------------------------------------------- */

  document.querySelectorAll('[data-gallery-thumbs]').forEach(function (thumbs) {
    thumbs.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-media-target]');
      if (!btn) return;
      event.preventDefault();
      var gallery = document.querySelector('[data-gallery]');
      var slide = gallery && gallery.querySelector('[data-media-id="' + btn.dataset.mediaTarget + '"]');
      if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      thumbs.querySelectorAll('[data-media-target]').forEach(function (el) { el.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ----------------------------------------------------------------------
     Header schaduw bij scrollen
     ---------------------------------------------------------------------- */

  var header = document.querySelector('[data-header]');
  var voortgang = document.querySelector('[data-voortgang]');

  if (header || voortgang) {
    var ticking = false;

    var meten = function () {
      ticking = false;
      var y = window.scrollY;

      if (header) header.classList.toggle('is-scrolled', y > 8);

      if (voortgang) {
        var loop = document.documentElement.scrollHeight - window.innerHeight;
        var deel = loop > 40 ? Math.min(1, Math.max(0, y / loop)) : 0;
        voortgang.style.setProperty('--voortgang', deel.toFixed(4));
        voortgang.classList.toggle('is-zichtbaar', y > 40 && loop > 40);
      }
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(meten);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    meten();
  }

  /* ----------------------------------------------------------------------
     Vaste bestelbalk op de productpagina
     Verschijnt zodra je de gewone knop voorbij bent gescrold.
     ---------------------------------------------------------------------- */

  var stickyBalk = document.querySelector('[data-product-sticky]');
  if (stickyBalk) {
    var hoofdKnop = document.querySelector('.product__add');
    var hoofdForm = hoofdKnop ? hoofdKnop.closest('form') : null;

    if (hoofdKnop && hoofdForm && 'IntersectionObserver' in window) {
      stickyBalk.hidden = false;

      var balkObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // alleen tonen als de knop boven het scherm uit is, niet als hij er nog onder zit
          var voorbij = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBalk.classList.toggle('is-zichtbaar', voorbij);
        });
      }, { threshold: 0 });
      balkObserver.observe(hoofdKnop);

      var stickyKnop = stickyBalk.querySelector('[data-sticky-add]');
      if (stickyKnop) {
        stickyKnop.addEventListener('click', function () {
          hoofdForm.requestSubmit ? hoofdForm.requestSubmit() : hoofdForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }

      // prijs in de balk meelopen met de gekozen variant
      var stickyPrijs = stickyBalk.querySelector('[data-sticky-price]');
      var bronPrijs = document.querySelector('[data-variant-price] .price__current');
      if (stickyPrijs && bronPrijs && 'MutationObserver' in window) {
        new MutationObserver(function () {
          stickyPrijs.textContent = bronPrijs.textContent;
        }).observe(bronPrijs, { childList: true, characterData: true, subtree: true });
      }
    }
  }

  /* ----------------------------------------------------------------------
     Rouleren op smalle schermen
     Toont een item tegelijk, zodat lange balken niet buiten beeld lopen.
     ---------------------------------------------------------------------- */

  var rotators = document.querySelectorAll('[data-rotate]');
  if (rotators.length && window.matchMedia) {
    var smal = window.matchMedia('(max-width: 749px)');

    Array.prototype.forEach.call(rotators, function (root) {
      var items = Array.prototype.filter.call(root.children, function (el) {
        return el.nodeType === 1;
      });
      if (items.length < 2) return;

      var index = 0;
      var timer = null;

      function toon(n) {
        items.forEach(function (el, i) {
          el.classList.toggle('is-active', i === n);
        });
      }

      function start() {
        if (timer) return;
        // een verborgen item wordt nooit door de onthul-observer gezien, dus zelf zetten
        items.forEach(function (el) { el.classList.add('is-revealed'); });
        root.classList.add('is-rotating');
        index = 0;
        toon(0);
        timer = setInterval(function () {
          index = (index + 1) % items.length;
          toon(index);
        }, 3800);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
        root.classList.remove('is-rotating');
        items.forEach(function (el) { el.classList.remove('is-active'); });
      }

      function sync() { if (smal.matches) { start(); } else { stop(); } }

      if (smal.addEventListener) smal.addEventListener('change', sync);
      else if (smal.addListener) smal.addListener(sync);
      sync();
    });
  }

  /* ----------------------------------------------------------------------
     Onthullen bij scrollen
     ---------------------------------------------------------------------- */

  var reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-revealed'); });
  }
})();
